import { createFileRoute } from "@tanstack/react-router";

import { PlanGate } from "~/components/app/plan-gate";
import { DatasourceNewPage } from "~/pages/datasource-new/datasource-new.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/datasources/new/",
)({
  component: () => (
    <PlanGate reason="datasources">
      <DatasourceNewPage />
    </PlanGate>
  ),
});
